import {
  GET_BRANDS_FAILURE,
  GET_BRANDS_REQUEST,
  GET_BRANDS_SUCCESS,
} from "./ActionType";

const initialState = {
  brands: [],
  loading: false,
  error: null,
};

export const brandReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BRANDS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_BRANDS_SUCCESS:
      return {
        ...state,
        brands: action.payload,
        loading: false,
        error: null,
      };
    case GET_BRANDS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
